/**
 * The one query that holds who the caller is (SPEC §10, `GET /api/me`).
 *
 * Shared by the shell, the picker, and `/no-access`, all reading the same
 * cache entry so the session is fetched once. Presentation only — every report
 * path re-resolves access server-side (§7.2).
 */

import { useQuery } from '@tanstack/react-query'

import { api } from './api'
import type { Me } from './types'

/** How long `/api/me` is trusted before it is refetched. */
export const ME_STALE_MS = 5 * 60 * 1000

export function useMe(): Me | undefined {
  const { data } = useQuery({ queryKey: ['me'], queryFn: api.me, staleTime: ME_STALE_MS })
  return data
}
